import styled from 'styled-components';
import { Popover, Tooltip } from 'react-bootstrap';

export const StyledMonthlyExpenses = styled.div`
    #section-to-print {
        position: absolute; 
        bottom: 5000px;
        width: 100%;
    }
    
    .report-top {
        margin: 25px 0;
    }

    .expenses-wrapper {
        border: 1px solid #6E74FF;
        box-shadow: 0px 3px 34px rgba(89, 102, 137, 0.05);
        border-radius: 25px;
        padding: 24px 19px;
    }

    .outside-headers {
        display: grid;
        gap: 20px;
        grid-template-columns: repeat(7, 1fr);
        font-weight: 700;
        font-size: 16px;
        margin: 7px 55px 16px 75px;
        text-align: start;
        white-space: nowrap;
        color: rgba(55, 54, 71, 0.7);
    }

    .expenses-cards-wrapper {
        display: flex;
        flex-direction: column;
        gap: 33px;
        padding-right: 20px;
        direction: ${({ ltr }) => ltr ? 'ltr' : 'rtl'};
        margin-left: 50px;
        margin-top: 10px;
    }

    .expenses-subtitle {
        font-size: 20px;
        font-weight: 700;
        margin-top: 30px;
        .currency-value {
          color: rgba(55, 54, 71, 0.6);
          font-weight: 400;
          margin-inline-start: 5px;
    }
  }
`

export const StyledExpensesCard = styled.div`
    padding: 15px 22px;
    background: rgba(255, 255, 255, 0.5);
    border: 1px solid #A8C0FF;
    box-shadow: 0px 3px 34px rgba(89, 102, 137, 0.05);
    border-radius: 11px;
    position: relative;

    .paid-check {
        position: absolute;
        top: -10px;
        left: ${({ ltr }) => ltr ? '-10px' : ''};
        right: ${({ ltr }) => ltr ? '' : '-10px'};
    }

    .first-row {
        display: grid;
        gap: 20px;
        grid-template-columns: repeat(7, 1fr);
        color: rgba(55, 54, 71, 0.7);

        .vendor {
            max-width: 110px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
        }
    }
    
    .second-row {
        margin-top: 16px;
        padding-top: 10px;
        border-top: 1px solid rgba(216, 210, 255, 0.5);
        display: flex;
        gap: 48px;
    }
    .expenses-info-inner-wrapper {
        display: flex;
        flex-direction: column;
        gap: 8px;
        font-size: 16px;
        
        .header {
            font-weight: 700;
        }
        .value, .header {
            color: rgba(55, 54, 71, 0.7);
            font-size: 16px;
            text-align: start;
        }

        .paid-text {
            color: var(--bllink-purple);
        }
    }
    .paid-panel {
        background: rgba(255, 255, 255, 0.96);
        border: 1px solid #D8D2FF;
        border-radius: 14px;
        height: 8px;
        width: 70px;
        position: relative;
        &::after {
            content: '';
            border-radius: 14px;
            height: 8px;
            background: linear-gradient(179.97deg, #6D8FFF -24.96%, #8467FF 99.97%), #70A6E8;
            width: ${({ paidPercent }) => paidPercent ? `${paidPercent}%` : ''};
            position: absolute;
            bottom: -1px;
            right: ${({ ltr }) => ltr ? '' : 0};
            left: ${({ ltr }) => ltr ? 0 : ''}
        }
    }

    .open-close-btn {
        position: absolute;
        right: ${({ ltr }) => ltr ? '12px' : ''};
        left: ${({ ltr }) => ltr ? '' : '12px'};
        top: 7px;
        width: 32px;
        height: 32px;
        background: #E9E9FD;
        border-radius: 50px;
        cursor: pointer;
        box-shadow: -2px 3px 7px 0 rgba(89, 102, 137, 0.35);
        display: flex;
        align-items: center;
        justify-content: center;

        img {
            margin-top: ${({ showSecondRow }) => showSecondRow ? '0' : '3px'};
            transform: ${({ showSecondRow }) => showSecondRow ? 'rotate(180deg)' : ''};
        }
    } 

    .tool {
        width: 32px;
        height: 32px;
        background-color: #E9E9FD;
        border-radius: 50px;
        cursor: pointer;
        transform: rotate(-90deg);
        color: var(--bllink-purple);
        font-weight: 600;
        position: absolute;
        left: -45px;
        top: 5px;
        display: flex;
        justify-content: center;
        box-shadow: -2px 3px 7px 0 rgba(89, 102, 137, 0.35);
    
        :hover {
          background: linear-gradient(180deg, #6E8EFF 0%, #8469FF 100%);
          color: #FFFFFF;
        }
    }
` 

export const StyledPopoverBody = styled(Popover.Body) `
    width: 200px;
`

export const StyledExpensesTooltip = styled(Tooltip)`
    .tooltip-inner {
        color: var(--bllink-purple);
        background-color: #FFFFFF;
        border: 1px solid rgba(216, 210, 255, 0.5);
    }
`